type TimelineImagePosition = {
  x: number;
  y: number;
};

export const timelineImagePositions: TimelineImagePosition[] = [
  {
    x: -20,
    y: -8,
  },
  {
    x: 20,
    y: 0,
  },
  {
    x: -20,
    y: 20,
  },
  {
    x: 8,
    y: 22,
  },
];
